/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpgradeTierStepDTO = {
    reason?: Array<string>;
    stepName?: string;
    stepNumber?: string;
    stepStatus?: UpgradeTierStepDTO.stepStatus;
};

export namespace UpgradeTierStepDTO {

    export enum stepStatus {
        NOT_STARTED = 'NOT_STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }


}

